import { CommonPageALMeta } from '@lemon8/web-app-shared/ssr';
import { url } from '.';
import { CAMPAIGN_ID, snssdk2657 } from '../constants';
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { $ShareInfo } from '~/models/share-info';
import { $Locale } from '@lemon8/web-app-shared/atom';

export const ActivityFacebookALMeta = () => {
  const { region } = useAtomValue($Locale);
  const webUrl = `${url}?region=${region}`;
  const { sharePlatform, sharePageName } = useAtomValue($ShareInfo);
  const schema = useMemo(() => {
    let str = snssdk2657;

    const commonParams: Record<string, string> = {
      pid: CAMPAIGN_ID,
      share_platform: sharePlatform,
      share_position: sharePageName,
    };

    Object.keys(commonParams).forEach((key) => {
      str += `&${key}=${encodeURIComponent(commonParams[key])}`;
    });
    return str;
  }, []);

  const alMetaInfo = {
    openUrl: schema,
    webUrl: webUrl,
  };

  return <CommonPageALMeta {...alMetaInfo} />;
};
